import React from "react";
import PageHeader from "../../components/organisms/PageHeader";
import fac1 from "../../assets/images/fac1.jpg"
import fac2 from "../../assets/images/fac2.jpg"
import fac5 from "../../assets/images/fac5.jpg"
import fac6 from "../../assets/images/fac6.jpg"
import fac7 from "../../assets/images/fac7.jpg"
import fac8 from "../../assets/images/fac8.jpg"
import fac9 from "../../assets/images/fac9.jpg"
import fac10 from "../../assets/images/fac10.jpg"
import fac11 from "../../assets/images/fac11.jpg"
import LeftSection from "../../components/organisms/LeftSection";
import RightSection from "../../components/organisms/RightSection";
import styled from "styled-components";
import {device} from "../../assets/styles/media";

const OperatingTime = styled.p`
    margin-top: 45px;
    font-size: 18px;
    letter-spacing: -0.45px;
    ${device.tablet} {
        font-size: 17px;
    }
    ${device.mobile} {
        margin-top: 0;
        font-size: 13px;
    }
`;

const Info = styled.div`
    margin-top: 35px;
    
    ${device.mobile} {
        margin-top: 10px;
    }
`;
const Dl = styled.dl`
    display: flex;
    ${device.mobile} {
        font-size: 13px;
    }`;
const Dt = styled.dt`
    color: #444;
    &::after {
        content: "";
        display: inline-block;
        width: 1px;
        height: 14px;
        margin: 0 10px -1px 0;
        background: #777;
    }
    span {
        display: inline-block;
        letter-spacing: -0.3px;
        width: 60px;
        text-align: left;
        font-weight: bold;
    }
    ${device.tablet} {
        span{
            font-size: 14px;
        }
        &::after {
            height: 14px;
            margin: 0 5px;
        }
    }
    ${device.mobile} {
        font-size: 13px;
        &::after {
            height: 10px;
            margin: 0 5px -1px 0;
        }
        span {
            font-weight: 500;
            width: 50px;
            font-size: 13px;
        }
    };
`;
const Dd = styled.dd`
    overflow: hidden;
    letter-spacing: -0.3px;
    color: #444444;
    display: block;
    ${device.tablet} {
        font-size: 14px;
   
    };
    ${device.mobile} {
        font-size: 13px;
        letter-spacing: -0.8px;
   
    };
`;

const TextBox = styled.div`
    color: #4a4a4a;
    font-size: 18px;
    line-height: 1.56;
    
    letter-spacing: -0.3px;

`;
const InfoList = styled.ul`
    margin-top: 10px;
`;
const Item = styled.li`
    ${device.tablet} {
        font-size: 17px;
        line-height: 35px;
      }
    ${device.mobile} {
        font-size: 13px;
        //font-weight: 600;
    }
`;


const Facility = () => {
    const textList = ( <>
        강아지를 양육하는 전문 MD가 200여 가지 품목을 하나하나 세심하게 엄선하여 골랐습니다. 강아지에게 선물하고 싶은 독특한 용품과 간식, 다양한 상품들을 합리적인 가격으로 만나보세요 .강아지와 함께 머물면 더욱 행복한 공간입니다
        .</>);
    const list3 = [
        '강아지 의무실은 가벼운 경상 등 응급처치만 가능합니다.',
        '그 이상의 의료 행위가 필요할 시 외부 동물병원에 방문하실 것을 권유드립니다.'
    ]

    const textList3 = '가벼운 외상 치료 등 응급 상황에 따른 초기 대처가 이루어지는 강아지 의무실은 병원에 가기 전 최소한의 치료를 받을 수 있도록 도와줍니다.';
    const textList4 = '전자시스템으로 작동하여 개인물품을 안전하게 보관할 수 있는 물품 보관소입니다. 사이즈 별로 보관공간이 마련되어 있어 편리하게 사용 할 수 있습니다.';
    const textList5 = '간단한 상처치료와 응급처치를 진행해드립니다. 친절한 안내와 서비스로 방문객의 마음에 따뜻한 안정을 찾아드립니다.';
    const textList6 = '엄마와 아빠가 편안하게 아기와 교감할 수 있는 공간입니다. 수유 공간이 별도로.마련되어 있으며 기저귀 교환대, 정수기 등 아기를 돌보는데 필요한 편의시설들이 갖추어져 있습니다.';
    return (
        <>
            <PageHeader
                bTitle="관람"
                detail="편의시설"
                desc="강아지숲 편의시설을 안내해 드립니다."
            />

            {/*section 1*/}
            <LeftSection
                title="강아지숲 마켓"
                enTitle="d.forest Market"
                subTitle="까다로운 기준으로 골랐습니다."
                textList={textList}
                content={<OperatingTime>운영시간 : 10:00 ~ 18:00</OperatingTime>}
                img1={fac1}
                img2={fac2}
            />


            {/*section 3*/}
            <RightSection
                title="강아지 의무실"
                enTitle="Dog Infirmary"
                subTitle="아프지마 강아지야."
                textList={textList3}
                content={<>
                    <Info>
                        <Dl>
                            <Dt><span>운영시간 </span></Dt> <Dd>강아지숲 운영 시간 내 상시 운영</Dd>
                        </Dl>
                        <Dl>
                            <Dt><span>치료범위 </span></Dt> <Dd>가벼운 외상, 응급처치</Dd>
                        </Dl>
                    </Info>
                    <TextBox>
                        {<InfoList>
                            {list3.map((item, index) => (<Item key={index}>{item}</Item>))}
                        </InfoList>}
                    </TextBox>
                </>
                }
                img1={fac5}
                img2={fac6}
                simbol={false}
            />
            {/*section 4*/}
            <LeftSection
                title="물품보관소"
                enTitle="Baggage Lockers"
                subTitle="소중한 개인물품을 안전하게 보관하세요."
                textList={textList4}
                content={<OperatingTime>운영시간 : 10:00 ~ 18:00</OperatingTime>}
                img1={fac7}
                img2={fac8}
            />

            {/*section 5*/}
            <RightSection
                title="의무실"
                enTitle="Infirmary"
                subTitle="간단한 치료를 도와드립니다."
                textList={textList5}
                content={<>
                    <Info>
                        <Dl>
                            <Dt><span>운영시간 </span></Dt> <Dd>강아지숲 운영 시간 내 상시 운영</Dd>
                        </Dl>
                        <Dl>
                            <Dt><span>치료범위 </span></Dt> <Dd>가벼운 외상, 응급처치</Dd>
                        </Dl>
                    </Info>
                    <TextBox>
                        <InfoList>
                        <Item >그 이상의 의료 행위가 필요할 시 외부 병원에 방문하실 것을 권유드립니다.</Item>
                        </InfoList>
                    </TextBox>
                </>
                }
                img1={""}
                img2={fac9}
                simbol={false}
            />

            {/*section 6*/}
            <LeftSection
                title="수유실"
                enTitle="Nursing Room"
                subTitle="편안하게 아기와 교감하세요."
                textList={textList6}
                content={<OperatingTime>운영시간 : 10:00 ~ 18:00</OperatingTime>}
                img1={fac10}
                img2={fac11}
            />
        </>
    );
};

export default Facility;
